import * as z from "zod";

export const commerceCloudIntegrationId = z.string().min(1);

export const commerceCloudIntegrationTarget = z.union([
  z.object({ integrationId: commerceCloudIntegrationId }),
  z.object({ allIntegrations: z.literal(true) }),
]);
export type CommerceCloudIntegrationTarget = z.infer<
  typeof commerceCloudIntegrationTarget
>;

const commerceCloudIntegrationSummary = z.object({
  id: z.string(),
  siteId: z.string(),
  siteIds: z.array(z.string()),
});
export type CommerceCloudIntegrationSummary = z.infer<
  typeof commerceCloudIntegrationSummary
>;

export const listCommerceCloudIntegrations = {
  name: "listCommerceCloudIntegrations" as const,
  input: z.object({}),
  output: z.object({ integrations: z.array(commerceCloudIntegrationSummary) }),
};
